import cc from "classcat";

const ModalFooter = ({ children, className = "", ...props }) => (
	<div className={cc(["modal-footer flex-grow-0", className])} {...props}>
		{children}
	</div>
);
export default ModalFooter;
